import React, { useEffect, useRef, useState } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { Stack } from "react-bootstrap";
import SelectorDiscipline from "../components/common/selectors/selector-discipline/selectorDiscipline";
import SelectorNoc from "../components/common/selectors/selector-noc";
import { useQuery } from "@tanstack/react-query";
import { getAthletes } from "../data/Querys";
import SelectorEvent from "../components/common/selectors/SelectorEvent";
import CoachesTable from "../components/common/participants/CoachesTable";
import NotAvailable from "../components/common/NotAvailable";
import Loader from "../components/general/Loader";
import { useGetH1 } from 'helpers/commonCodes';
import { ALL_URL, SELECTOR_DISPLAY_TYPE } from 'helpers/utils';
import { ResetFilterButton } from 'components/common/ResetFilterButton';
import { useLabels } from 'components/general/Label';


export default function Coaches() {
    const [dataState, setDataState] = useState([]);
    const { mirs_competition, mirs_language, mirs_discipline, mirs_noc, mirs_event } = useUrlFriendlyToParameters();
    const [nameFilter, setNameFilter] = useState('');
    const [disciplines, setDisciplines] = useState([]);
    const [nocs, setNocs] = useState([]);
    const [events, setEvents] = useState([]);
    const { h1s } = useGetH1({ mirs_competition });
    const inputRef = useRef(null);
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelSearch' });
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['athletes', mirs_competition, mirs_language, 'C'],
            queryFn: getAthletes,
            refetchInterval: 0

        });

    useEffect(() => {
        const discArray = h1s.filter(h => h.orisNo === 'N21').map(h => h.disciplineCode) || [];

        let filterData = data?.persons;
        filterData = data?.persons?.filter(item => item?.disciplines?.some(itemDiscipline => discArray.includes(itemDiscipline?.code)));
        filterData = filterData?.filter(item => ['HED_COA', 'COACH'].includes(item?.mainFunction?.functionCode));

        let tempDisciplines = new Set();
        let tempNocs = new Set();
        let tempEvents = new Set();

        filterData?.forEach(dataItem => {
            let tempDisciplineArray = [];
            dataItem?.disciplines?.forEach(d => {
                if (d?.code) {
                    tempDisciplineArray.push(d?.code)
                }
            });
            let tempNoc = dataItem?.organisation?.code;
            let tempEventArray = [];
            dataItem?.registeredEvents?.forEach(re => {
                tempEventArray.push(re?.code)
            });

            if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
                if (!dataItem?.disciplines?.some(d => d?.code === mirs_discipline)) {
                    tempNoc = "";
                    tempEventArray = [];
                };

                if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
                    if (!dataItem?.registeredEvents?.some(re => re.code === mirs_event)) {
                        tempNoc = "";
                    }
                }
            }

            if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
                if (dataItem?.organisation?.code !== mirs_noc) {
                    tempDisciplineArray = [];
                    tempEventArray = [];

                };
            };

            if (tempNoc) {
                tempNocs.add(tempNoc);
            }

            tempDisciplineArray.forEach(te => tempDisciplines.add(te));
            tempEventArray.forEach(te => tempEvents.add(te));
        });

        if (mirs_discipline && mirs_discipline !== "all-disc")
            filterData = filterData?.filter(item => item?.disciplines?.some(itemDiscipline => itemDiscipline?.code === mirs_discipline))
        if (mirs_noc && mirs_noc !== "all-noc")
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        if (mirs_event && mirs_event !== "all-event")
            filterData = filterData?.filter(item => item?.registeredEvents?.find(e => e?.code === mirs_event));
        if (nameFilter)
            filterData = filterData?.filter(item => item?.name?.toLowerCase().includes(nameFilter?.toLowerCase()));
        setDataState(filterData);
        setDisciplines([...tempDisciplines]);
        setEvents([...tempEvents]);
        setNocs([...tempNocs])
    }, [data, mirs_noc, mirs_discipline, mirs_event, h1s, nameFilter]);


    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.persons) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }


    const handleOnChange = event => {
        const { name, value } = event.target;
        let val = value;
        val = val.trimEnd();
        setNameFilter(val);
    };

    const clearFilterText = () => {
        if (inputRef?.current?.value) {
            inputRef.current.value = "";
        };
        setNameFilter("");
    };
    return (
        <div className='mirs-page-container'>
            <Stack direction="horizontal" className='selectors-container'>
                <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="coaches" disciplinesList={disciplines} useDisciplinesList={true} />
                <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="coaches" nocsList={nocs} useNocList={true} />
                <SelectorEvent display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="coaches" eventList={events} useEventList={true} />
                <div className="d-flex competitor-search">
                    {/*<label htmlFor="city"><Label data={"HeaderNOC"} /></label>*/}
                    <input ref={inputRef} type="text" className="form-control" name="Search" id="Search" placeholder={placeholder}
                        onChange={handleOnChange} />
                </div>
                <ResetFilterButton clearFilterText={clearFilterText} filterText={nameFilter} page='coaches' />
            </Stack>
            <div>
                {dataState && <CoachesTable data={dataState} key={`coaches`} />}
            </div>
        </div>
    )
};